import React from 'react'

function SingleScheme() {
  return (
    <div>SingleScheuuuuuuuuuuuuuuuuuuume</div>
  )
}

export default SingleScheme